// extracted by mini-css-extract-plugin
module.exports = {"mailToLinkWrapper":"MailTo_mailToLinkWrapper__iftJD","mailToLink":"MailTo_mailToLink__18YCc"};